import { Image } from '@/services/Api/generated'

export class Thumbnail {
  get original() {
    return this.images.find((image) => image.conversionName === 'original')
  }

  get desktop() {
    return this.images.find((image) => image.conversionName === 'pc')
  }

  get tablet() {
    return this.images.find((image) => image.conversionName === 'tablet')
  }

  get mobile() {
    return this.images.find((image) => image.conversionName === 'mobile')
  }

  constructor(public images: Image[]) {}
}
